import {WlModalField} from "./modalField.component";

export * from './modalField.component';
export default WlModalField;

customElements.define('wl-modal-field', WlModalField);